<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';

export default {
  mixins: [fandomBasicMixin]
};
</script>

<template>
  <div page-article-red-banner-component>
    <div class="bg-primary text-light">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-7">
            <div class="row align-items-center">
              <div class="col py-2">
                <p class="font-weight-bold mb-0 h5">{{content.title}}</p>
                <p class="mb-0 h6">{{content.description}}</p>
              </div>
              <div class="col-auto text-center">
                <a class="btn btn-outline-light px-3 py-0 text-uppercase" :target="getTarget(content.button)" :href="content.button.url">{{content.button.title}}</a>
              </div>
            </div>  
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
[page-article-red-banner-component] {

  .btn {
    letter-spacing: 1px;
    font-weight: $font-weight-bold;
    font-size: 1.25rem;

    @include media-breakpoint-down(sm) {
      font-size: 1rem;
    }
  }

}
</style>
